<!-- -->
<template>
  <div :class="{ baidu_search: true, mm: isMobile }">
    <div class="box">
      <div class="title-box">
        <div class="title">百度开屏广告</div>
        <div class="type">基于大数据赋能和意图营销的优质移动营销产品</div>
      </div>
      <div id="special">
        <div class="specials swiper-wrapper">
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'ad_img1.png'" alt="" />
            </div>
            <div class="title">AI智能</div>
            <div class="desc" style="width: 71%">
              动态捕捉潜在核心目标受众，定向准，数据精，智能化
            </div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'ad_img2.png'" alt="" />
            </div>
            <div class="title">定向精准</div>
            <div class="desc" style="width: 71%">
              支持多维度定向方式，助力广告主精准锁定目标人群
            </div>
          </div>
          <div class="special swiper-slide">
            <div class="post">
              <img :src="URL + 'ad_img3.png'" alt="" />
            </div>
            <div class="title">多产品联投</div>
            <div class="desc">多品牌广告联动，实现全域品牌集中大曝光</div>
          </div>
        </div>
        <div class="swiper-pagination"></div>
      </div>
      <button class="get" @click="$emit('openDialog')">立即获取专属流量</button>
    </div>
    <div class="box2">
      <div class="title-box">
        <div class="title">广告展现形式</div>
        <div class="type">
          覆盖用户24小时工作生活全时长 | 覆盖近9成移动互联网主流人群
        </div>
      </div>
      <div class="content">
        <div class="types">
          <div
            :class="{ type: true, active: activeType == idx }"
            @mouseenter="changeType(idx)"
            v-for="(item, idx) in typeList"
            :key="item.logo"
          >
            <img :src="item.logo" alt="" class="logo" />
          </div>
        </div>
        <div class="desc">
          <div
            class="desc_content"
            v-show="activeType == idx"
            v-for="(item, idx) in typeList"
            :key="item.logo"
          >
            <img :src="item.bg" alt="" class="bg" />
            <div class="card">
              <div class="info">{{ item.info }}</div>
              <img :src="item.logo" alt="" class="logo" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { URL } from "@/util/config";
import { Store } from "@/store/index.js";
import { mapState } from "pinia";

export default {
  data() {
    return {
      URL,
      activeType: 0,
      typeList: [
        {
          name: "百度APP",
          logo: "http://gxbg.pangodso.com/file/ad_icon1.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg1.jpg",
          info: "新闻资讯场景\n工具应用场景",
        },
        {
          name: "百度地图",
          logo: "http://gxbg.pangodso.com/file/ad_icon2.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg2.jpg",
          info: "通勤出行场景",
        },
        {
          name: "小度",
          logo: "http://gxbg.pangodso.com/file/ad_icon3.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg3.jpg",
          info: "生活服务场景",
        },
        {
          name: "好看视频",
          logo: "http://gxbg.pangodso.com/file/ad_icon4.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg4.jpg",
          info: "休闲娱乐场景",
        },
        {
          name: "百度手机助手",
          logo: "http://gxbg.pangodso.com/file/ad_icon5.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg5.jpg",
          info: "工具应用场景",
        },
        {
          name: "百度网盘",
          logo: "http://gxbg.pangodso.com/file/ad_icon6.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg6.jpg",
          info: "工具应用场景",
        },
        {
          name: "百度知道",
          logo: "http://gxbg.pangodso.com/file/ad_icon7.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg7.jpg",
          info: "工具应用场景",
        },
        {
          name: "百度贴吧",
          logo: "http://gxbg.pangodso.com/file/ad_icon8.png",
          bg: "http://gxbg.pangodso.com/file/ad_bg8.jpg",
          info: "休闲娱乐场景\n社交互动场景",
        },
      ],
    };
  },
  computed: {
    ...mapState(Store, ["isMobile"]),
  },
  mounted() {
    if (this.isMobile) {
      this.initSpecial();
    }
  },
  methods: {
    initSpecial() {
      new window.Swiper("#special", {
        // loop: true,
        centeredSlides: true,
        slidesPerView: 1.5,
        pagination: {
          el: "#special .swiper-pagination",
        },
      });
    },
    changeType(type) {
      this.activeType = type;
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.box {
  margin-top: 100px;
}
.title-box {
  text-align: center;

  .title {
    color: #0d0d0d;
    font-weight: bold;
    font-size: 30px;
    letter-spacing: 1px;
  }
  .type {
    color: #6e7685;
    letter-spacing: 6px;
    margin-top: 30px;
  }
}
.description {
  width: 1200px;
  font-size: 15px;
  margin: 40px auto 0;
  letter-spacing: 2px;
  line-height: 30px;
}
.float {
  width: fit-content;
  position: relative;
  margin: 50px auto 0;

  .center {
    width: 600px;
  }
  .out {
    position: absolute;
    display: flex;
    align-items: flex-start;

    .icon {
      width: 73px;
    }
    .text {
      margin-left: 15px;
      margin-top: 10px;

      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .desc {
        margin-top: 5px;
        color: #6e7685;
        line-height: 25px;
        letter-spacing: 2px;
      }
    }
  }
}
.specials {
  width: 1200px;
  margin: 30px auto 0;
  display: flex;
  justify-content: space-between;

  .special {
    width: 32%;
    text-align: center;

    .post {
      width: 100%;
      height: 314px;
      overflow: hidden;

      &:hover {
        img {
          transform: scale(1.1);
        }
      }
      img {
        width: 100%;
        height: 100%;
        display: block;
        transition: 0.5s;
      }
    }
    .title {
      font-size: 20px;
      margin-top: 15px;
    }
    .desc {
      width: 70%;
      margin: 15px auto 0;
      color: #6e7685;
      line-height: 26px;
    }
  }
}
.get {
  width: 300px;
  height: 50px;
  margin: 70px auto;
  text-align: center;
  line-height: 50px;
  font-size: 20px;
  border-radius: 10px;
  background-color: $theme;
  color: #fff;
  display: block;
}

.box2 {
  background-color: #f5f7fa;
  padding: 80px 0 180px;

  .content {
    margin-top: 90px;

    .types {
      width: 1200px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-evenly;

      .type {
        cursor: pointer;
        transition: 0.2s;

        &:hover {
          transform: scale(1.3);
        }
        & + .type {
          margin-left: 60px;
        }
        .logo {
          width: 81px;
        }
      }
      .active {
        position: relative;

        &::after {
          content: "";
          display: block;
          width: 40px;
          height: 5px;
          background-color: $theme;
          border-radius: 2px;
          position: absolute;
          left: 50%;
          top: 105px;
          transform: translateX(-50%);
        }
      }
    }

    .desc {
      margin-top: 100px;

      .desc_content {
        position: relative;
        animation: fadeIn 0.5s linear;

        .bg {
          width: 100%;
          height: 670px;
          object-fit: cover;
        }
        .card {
          width: 260px;
          height: 250px;
          padding-top: 50px;
          box-sizing: border-box;
          border-radius: 9px;
          background-color: rgba($color: #fff, $alpha: 0.6);
          text-align: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-190%, -50%);

          &::after {
            content: "";
            display: block;
            width: 40px;
            height: 5px;
            border-radius: 2px;
            background-color: #626262;
            position: absolute;
            left: 50%;
            top: 25px;
            transform: translateX(-50%);
          }
          .info {
            font-size: 26px;
            line-height: 35px;
            white-space: pre-wrap;
          }
          .logo {
            width: 55px;
            margin-top: 20px;
          }
          .name {
            font-size: 14px;
            color: #272727;
            letter-spacing: 2px;
          }
        }
        .icon {
          width: 100px;
        }
        .title {
          font-size: 20px;
          margin-top: 40px;
        }
        .sub {
          color: #6e7685;
          line-height: 26px;
          margin-top: 10px;
        }
      }
    }
  }
}

.mm {
  .box {
    margin-top: 60px;
  }
  .title-box {
    .title {
      font-size: 22px;
    }
    .type {
      padding: 0 10px;
      font-size: 15px;
      margin-top: 10px;
      letter-spacing: 1px;
    }
  }
  .description {
    width: 100%;
    padding: 0 10px;
    line-height: 1.5;
    box-sizing: border-box;
    font-size: 14px;
    letter-spacing: 1px;
  }
  #special {
    overflow: hidden;
    position: relative;
    padding-bottom: 30px;

    :deep(.swiper-slide) {
      transform: scale(0.9);
      z-index: 10;
    }
    :deep(.swiper-slide-active) {
      transform: scale(1);
      z-index: 10;
    }
  }
  .specials {
    width: 100%;

    .special {
      width: 100%;
      margin-bottom: 10px;

      .post {
        height: 204px;
      }
      .title {
        font-size: 18px;
        margin-top: 10px;
      }
      .desc {
        width: 80% !important;
        font-size: 14px;
        margin-top: 0;
        line-height: 1.5;
      }
    }
  }
  .get {
    width: 60%;
    font-size: 14px;
    height: 40px;
    line-height: 40px;
    margin: 20px auto;
  }
  .box2 {
    padding-bottom: 40px;

    .content {
      width: 100%;
      margin-top: 30px;

      .types {
        width: 100%;
        padding: 0 10px;
        box-sizing: border-box;
        flex-wrap: nowrap;
        overflow: auto;

        .type {
          padding: 0 10px;
          margin-bottom: 20px;

          &:hover {
            transform: none;
          }
          & + .type {
            margin-left: 0;
          }
          .logo {
            width: 50px;
          }
        }
        .active::after {
          top: 60px;
        }
      }
      .desc {
        margin-left: 0;
        margin-top: 20px;

        .desc_content {
          width: 100%;

          .bg {
            height: 240px;
          }
          .card {
            width: 40vw;
            height: 40vw;
            padding-top: 20px;
            transform: translate(-100%, -50%);

            &::after {
              height: 2px;
              top: 10px;
            }
            .info {
              font-size: 13px;
              line-height: 1.3;
              font-weight: bold;
            }
            .logo {
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 1400px) {
  .float .center {
    width: 500px;
  }
  .float .out .text .desc {
    font-size: 14px;
  }
  .description {
    width: 1000px;
  }
  .box2 .content {
    .types {
      width: 1000px;

      .type .logo {
        width: 60px;
      }
      .active::after {
        width: 30px;
        height: 4px;
        top: 80px;
      }
    }
    .desc .desc_content .item {
      .title {
        font-size: 20px;
      }
      .sub {
        font-size: 14px;
      }
    }
  }
}
</style>
